import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { Nav, Tab } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import axios from 'axios';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import moment from "moment";
import Analytics from './feedbacksurveycomp/Analytics';
import FeedBackList from './feedbacksurveycomp/FeedBackList';
import CreateFeedback from './feedbacksurveycomp/CreateFeedback';
import FilterDateRange from './feedbacksurveycomp/FilterDates/FilterDateRange';
import DateRangeSelector from './feedbacksurveycomp/FilterDates/DateRangeSelector';
import { exportMultipleChartsToPdf } from '../../utils/pdf';
import ProPopup from '../../layouts/ProPopup';
import { CrownIcon } from '../../assets/icons/iconshere';

const Feedback = () => {
  const location = useLocation();
  const { state } = location;
  const configData = useSelector((state) => state.configSlice);
  const userData = useSelector((state) => state.userSlice);
  const [activeTabAnalytics, setActiveTabAnalytics] = useState('feedbacklist');
  const [filter, setFilter] = useState('all');
  const [showFilter, setShowFilter] = useState(false);
  const [show, setShow] = useState(false);
  const [analyticsData, setAnalyticsData] = useState({});
  const [statsLoading, setStatsLoading] = useState(false);
  const [statsData, setStatsData] = useState({
    feedbacksCount: 0,
    surveysCount: 0,
    feedbackResponseCount: 0,
    surveyResponseCount: 0,
  });
  const [loading, setLoading] = useState(true)

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [openPro, setOpenPro] = useState(false);
  const [userPlan, setUserPlan] = useState(null);

  useEffect(() => {
    if (userData.plans.data) setUserPlan(userData.plans.data);
  }, [userData]);

  const getFeedbackStatsData = async () => {
    try {
      setStatsLoading(true);
      const { data } = await axios.get(`${configData.config.UNO_URL}/api/feedback/stats/data`, {
        headers: {
          Authorization: `Bearer ${userData.token}`,
        },
        params: {
          filter: filter,
        }
      });

      setStatsData({
        feedbacksCount: data.data.feedbackCount,
        surveysCount: data.data.feedbackResponseCount,
        feedbackResponseCount: data.data.surveyCount,
        surveyResponseCount: data.data.surveyResponseCount
      });

    } catch (error) {
      console.log(error);
    } finally {
      setStatsLoading(false);
    }
  };

  const getAnalytics = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get(`${configData.config.UNO_URL}/api/feedback/dashboard/analytics`, {
        headers: {
          Authorization: `Bearer ${userData.token}`,
        },
        params: {
          filter: filter,
        }
      });

      setAnalyticsData(data.data || {});

    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false)
    }
  };

  useEffect(() => {
    getFeedbackStatsData();
    getAnalytics();
  }, [filter])


  useEffect(() => {
    if (state?.key) {
      setActiveTabAnalytics(state.key);
    }
  }, []);

  const handleTabChange = (tab) => {
    setActiveTabAnalytics(tab);
  };

  const DateRangeOpen = () => {
    setShowFilter(!showFilter);
  };

  const tableData = [
    ["Feedback and Management Survey Report", ""],
    ["Name", userData?.user?.name],
    ["Report Created at ", moment().format('ll')],
  ];

  return (
    <>

      <Tab.Container id="nested-tabs" activeKey={activeTabAnalytics} onSelect={handleTabChange}>
        <div className="row justify-content-between py-3 pt-0">
          <div className="col-md-4">
            <Nav className="tabsproduct" variant="tabs">
              {/* <Nav.Item>
                <Nav.Link eventKey="analytics">Analytics</Nav.Link>
              </Nav.Item> */}
              <Nav.Item>
                <Nav.Link eventKey="feedbacklist">Feedback & Survey List</Nav.Link>
              </Nav.Item>
            </Nav>
          </div>

          <div className="col-md-8">
            <div className="d-flex justify-content-md-end gap-3 mt-3 mt-md-0 csvuploaddownload">
              {activeTabAnalytics === 'analytics' && (
                <>
                  <DateRangeSelector selected={filter} setSelected={(e) => setFilter(e)} />

                  <div>
                    <button type='button' onClick={userPlan?.feedbackAndSurvey?.download ? () => exportMultipleChartsToPdf(tableData) : () => setOpenPro(true)} className="uloadoanload">
                      <FileDownloadOutlinedIcon />
                      <span>Report</span>
                    </button>
                  </div>

                </>
              )}

              {userData?.user?.permissions?.includes("GENERAL.FEEDBACK.CREATE") &&
                userPlan?.feedbackAndSurvey?.create ?
                <div className="mt-3 mt-md-0">
                  <div className="mt-3 mt-md-0">
                    <button type='button' className="createbtn" onClick={handleShow}>
                      Create Feedback & Survey
                    </button>
                  </div>
                </div>
                :
                <div className="mt-3 mt-md-0">
                  <button className="DefaultRedBtn pro " onClick={() => setOpenPro(true)}>
                    <AddOutlinedIcon /> <p> Feedback & Survey </p>
                  </button>
                </div>
              }

            </div>

          </div>

        </div>
        <Tab.Content>

          <Tab.Pane eventKey="analytics">
            <Analytics loading={loading} analyticsData={analyticsData} statsData={statsData} statsLoading={statsLoading} />
          </Tab.Pane>

          <Tab.Pane eventKey="feedbacklist">
            <FeedBackList />
          </Tab.Pane>

        </Tab.Content>
      </Tab.Container>

      <CreateFeedback show={show} handleClose={handleClose} />

      {showFilter && (
        <>
          <div onClick={DateRangeOpen} className="overlaydf" />
          <FilterDateRange />
        </>
      )}

      <ProPopup openPro={openPro} setOpenPro={setOpenPro} />
    </>
  );
};

export default Feedback;
